/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SharedFavoritesProvider_viewer$ref = any;
export type SharedFavoritesProviderRefetchQueryVariables = {
    readonly loadPortfolioData?: boolean | null;
    readonly selectedItemIds?: ReadonlyArray<string | null> | null;
    readonly userIds?: ReadonlyArray<string | null> | null;
    readonly shouldFillInFolder?: boolean | null;
};
export type SharedFavoritesProviderRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": SharedFavoritesProvider_viewer$ref;
    } | null;
};
export type SharedFavoritesProviderRefetchQuery = {
    readonly response: SharedFavoritesProviderRefetchQueryResponse;
    readonly variables: SharedFavoritesProviderRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]",
            "defaultValue": ([] /*: any*/)
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]",
            "defaultValue": ([] /*: any*/)
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFillInFolder",
            "type": "Boolean",
            "defaultValue": false
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "Variable",
        "name": "itemIds",
        "variableName": "selectedItemIds"
    } as any), v5 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        } as any),
        (v2 /*: any*/)
    ], v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": (v5 /*: any*/)
    } as any), v7 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SharedFavoritesProviderRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SharedFavoritesProvider_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "loadPortfolioData",
                                    "variableName": "loadPortfolioData"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "selectedItemIds",
                                    "variableName": "selectedItemIds"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldFillInFolder",
                                    "variableName": "shouldFillInFolder"
                                },
                                (v1 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SharedFavoritesProviderRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFillInFolder",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "folderItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "FOLDER"
                                            ]
                                        },
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v6 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        (v4 /*: any*/),
                                        (v7 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioItemId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v6 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        (v7 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v5 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SharedFavoritesProviderRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/SharedFavoritesProviderRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '23bcf7685f5f39a1e2b939714513711c';
export default node;
